import request from "./request";
/**
 * 分页查询商业收益信息
 * @param appId 应用id
 * @param pageNumber 当前页数
 * @param pageSize 页数大小
 */
export default async function getBusinessPage(params = {}) {
  const defaultParams = {
    pageNumber: 1,
    pageSize: 10,
  };
  return await request.get("/spin/dataBusiness/getBusinessPage", {
    params: { ...defaultParams, ...params },
  });
}
